import React, { useState } from "react";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
    Row,
    Col,
} from "reactstrap";
import { addDeveloperTicket } from "helpers/fakebackend_helper";

const AddDeveloperTicket = ({ onSave }) => {
    const [modal, setModal] = useState(false);
    const [formData, setFormData] = useState({
        subject: "",
        description: "",
        file: null,
    });
    const [isSaving, setIsSaving] = useState(false);
    const [done, setDone] = useState(false);

    const toggle = () => setModal(!modal);

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleFileChange = e => {
        setFormData(prev => ({ ...prev, file: e.target.files[0] }));
    };

    const handleSave = async () => {
        try {
            setIsSaving(true);
            const user = JSON.parse(localStorage.getItem("authUser"));
            const fd = new FormData();
            fd.append("subject", formData.subject);
            fd.append("description", formData.description);
            if (formData.file) fd.append("file", formData.file);

            const res = await addDeveloperTicket(user.token, fd);

            if (res.code === 1) {
                if (onSave) onSave();
                setDone(true);
                setTimeout(() => {
                    setDone(false);
                    toggle();
                    setFormData({ subject: "", description: "", file: null });
                }, 1500);
            }
        } catch (err) {
            console.error("Error adding ticket:", err);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="mb-3">
            <Button onClick={toggle} className="button-gradient-bg">
                Add Ticket
            </Button>

            <Modal isOpen={modal} toggle={toggle} centered>
                <ModalHeader toggle={toggle}>Add Developer Ticket</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label>Subject</Label>
                            <Input
                                value={formData.subject}
                                onChange={e => handleChange("subject", e.target.value)}
                                placeholder="Enter ticket subject"
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Description</Label>
                            <Input
                                type="textarea"
                                value={formData.description}
                                onChange={e => handleChange("description", e.target.value)}
                                placeholder="Describe the issue"
                            />
                        </FormGroup>

                        <Row>
                            <Col xl={12}>
                                <FormGroup>
                                    <Label>Attachment (optional)</Label>
                                    <Input type="file" onChange={handleFileChange} />
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="text-end">
                            <Button color="success" onClick={handleSave} disabled={isSaving || done}>
                                {done
                                    ? "Done"
                                    : isSaving
                                        ? <span className="spinner-border spinner-border-sm me-1" role="status" />
                                        : "Save"}
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default AddDeveloperTicket;